import cx from 'classnames'
import Toggle from 'components/Toggle'
import './style.styl'

const PlaybookDraftToggle = ({ className, ...props }) => (
  <span className="playbook-toggle-container">
    <Toggle
      className={cx('playbook-toggle', className)}
      icons={{
        checked: <span>On</span>,
        unchecked: <span>Off</span>,
      }}
      defaultValue={props.defaultValue}
      checked={props.checked}
      onChange={props.onChange}
    />
  </span>
)

export default PlaybookDraftToggle



// WEBPACK FOOTER //
// ./src/scripts/components/playbook/components/PlaybookDraftToggle/component.js